import { useRef, useState, useEffect } from 'react';
import { useTheme } from '@simplywallst/ui-core';
import { Value, LabelWrapper } from './styled';
import InsiderCount from '../InsiderCount';
import { VisxText } from '@/components/VisxText';

interface Props {
  companies: number;
  individuals: number;
  shares: number;
  type: 'bought' | 'sold';
  value: string;
  y: number;
  height: number;
  width: number;
  stack: boolean;
  labels?: {
    label1: string;
    label2: string;
  };
}

const Label = ({
  companies,
  individuals,
  shares,
  type,
  value,
  height,
  width,
  stack = false,
  y,
  labels = {
    label1: `${shares.toLocaleString()} shares`,
    label2: `approx. ${value}`,
  },
}: Props) => {
  const theme = useTheme();
  const titleRef = useRef<SVGSVGElement>(null);
  const [insiderCountX, setInsiderCountX] = useState(0);

  useEffect(() => {
    const { current } = titleRef;
    if (current) {
      let x = 0;
      if (stack === false) {
        if (type === 'sold') {
          x = width - current.getBBox().width - 16;
        } else {
          x = current.getBBox().width + 16;
        }
      } else {
        if (type === 'sold') {
          x = width;
        }
      }
      setInsiderCountX(x);
    }
  }, [stack, type, width, shares]);

  return (
    <LabelWrapper
      y={y}
      x="0"
      width={width}
      height={height}
      shapeRendering="crispEdges"
    >
      <VisxText
        x={type === 'sold' ? width : 0}
        y="2"
        innerRef={titleRef}
        fill={theme.color.whiteRGBA(shares > 0 ? 1 : 0.3)}
        textAnchor={type === 'sold' ? 'end' : 'start'}
        verticalAnchor="start"
        data-cy-id={`chart-insider-trading-shares-${type}`}
        typography="tiny"
      >
        {shares > 0 ? labels.label1 : `0`}
      </VisxText>
      {shares > 0 && (
        <Value
          x={type === 'sold' ? width : 0}
          y={theme.x2spacePx + 4}
          dominantBaseline="hanging"
          textAnchor={type === 'sold' ? 'end' : 'start'}
        >
          {labels.label2}
        </Value>
      )}
      {shares > 0 && (
        <InsiderCount
          x={insiderCountX}
          y={stack ? theme.x4spacePx + 3 : -6}
          companies={companies}
          individuals={individuals}
          type={type}
        />
      )}
    </LabelWrapper>
  );
};

export default Label;
